export default __webpack_public_path__ + "static/media/iago-castro.642e949a.jpg";